export default __webpack_public_path__ + "static/escapegoats-f3061afd8da0c8ab1121c1bbc90f2058.png";